module.exports = __webpack_public_path__ + "media/dorobek/assets/images/icons/Achievement-51b994a5040228039806bb3e67165af0.svg";